import {Button, Divider, List, ListItem, Radio, RadioGroup, Stack, Typography, useTheme} from "@mui/joy";
import {applyTransparency} from "../../../../../theme";
import React, {useEffect} from "react";
import {Question, QuestionAttempt, QuestionGroup, RawQuestion} from "../../../../../models/question";
import {useTestRoom} from "../../../../../hooks/useTestRoom";
import {SectionName} from "../../../../../models/section";


const IeltsTrueFalseQuestionComponent = (props: {
    question: RawQuestion,
    questionGroupIndex: number,
    questionId: string,
    subSectionNumber: number,
    testId: string,
    sectionName: SectionName,
}) => {
    const theme = useTheme()
    const testRoom = useTestRoom()
    const questionAttempt = testRoom.questionAttempts.find(value => {
        if (!!props.questionGroupIndex)
            return value.questionId === props.questionId && value.questionGroupIndex === props.questionGroupIndex
        else
            return value.questionId === props.questionId
    })
    const previousQuestionsCount = testRoom.questions
        .filter(q => q.subSectionNumber < testRoom.currentSubsectionNumber)
        .reduce((sum, q) => sum + (q as QuestionGroup).questions.length, 0)
    const questionNumber = previousQuestionsCount + props.questionGroupIndex + 1

    return <Stack paddingY={2} gap={3}>
        <Stack>
            <Typography level={"title-lg"}>
                Question {questionNumber}
            </Typography>
            <Typography>
                {props.question.content}
            </Typography>
        </Stack>

        <RadioGroup value={questionAttempt?.userAnswer as string}
                    onChange={(event) => testRoom.answerQuestion(event.target.value, props.question, {
                        questionId: props.questionId,
                        isFromGroup: !!props.questionGroupIndex,
                        questionGroupIndex: props.questionGroupIndex,
                        testId: props.testId,
                        sectionName: props.sectionName,
                        contentType: 'text'
                    })}
        >
            <List
                sx={{
                    minWidth: 240,
                    '--List-gap': '0.8rem',
                    '--ListItem-paddingY': '1rem',
                    '--ListItem-radius': '8px',
                    '--ListItemDecorator-size': '32px',
                }}
            >
                {["true", "false", "not given"].map((item, index) => (
                    <ListItem variant="outlined" key={item} sx={{
                        borderRadius: 15,
                        backgroundColor: applyTransparency(theme.palette.neutral['400'], 0.2)
                    }}>
                        <Radio
                            overlay
                            value={item}
                            label={<Typography textColor={"text.primary"}>
                                {item}
                            </Typography>}
                            color={item === questionAttempt?.userAnswer as string ? "primary" : "neutral"}
                            sx={{flexGrow: 1, color: "primary.500"}}
                            slotProps={{
                                action: ({checked}) => ({
                                    sx: (theme) => ({
                                        ...(checked && {
                                            inset: -1,
                                            border: '2px solid',
                                            borderRadius: 15,
                                            textTransform: "capitalize",
                                            backgroundColor: applyTransparency(theme.palette.primary[500], 0.3),
                                            borderColor: theme.palette.primary[500],
                                        }),
                                    }),
                                }),
                            }}
                        />
                    </ListItem>
                ))}
            </List>
        </RadioGroup>
    </Stack>
}

export default IeltsTrueFalseQuestionComponent